import { render, staticRenderFns } from "./SmConfigMgr.vue?vue&type=template&id=4bdcd13d&"
import script from "./SmConfigMgr.vue?vue&type=script&lang=js&"
export * from "./SmConfigMgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports